export default __webpack_public_path__ + "static/media/Hassleholm_full.dbeb7e7c.png";